import { 
    ADD_CONSULTATION_NOTES_DATA, 
    CLEAR_CONSULTATION_NOTES_DATA, 
    DEL_CONSULTATION_NOTES_DATA, 
    DOWNLOAD_CONSULTATION_NOTES_EXCEL, 
    DOWNLOAD_PENDING_NOTES_EXCEL, 
    GET_CONSULTATION_NOTES_DATA, 
    GET_LAB_TESTS, 
    GET_NOTES_TYPE_LIST, 
    GET_PREVIOUS_CONSULTATION_NOTE_BY_TYPE, 
    GET_SESSION_LIST_AGAINST_TO_NOTES, 
    UPDATE_CONSULTATION_NOTES_DATA, 
    UPDATE_CONSULTATION_NOTES_VISIBLE_STATUS
} from '../../constants';

export function clearConsultationNotes(data) {
    return {
        type: CLEAR_CONSULTATION_NOTES_DATA,
        data
    };
}

export function getConsultationNotes(data) {
    return {
        type: GET_CONSULTATION_NOTES_DATA,
        data
    };
}

export function addConsultationNotes(data) {
    return {
        type: ADD_CONSULTATION_NOTES_DATA,
        data
    };
}

export function updateConsultationNotes(data) {
    return {
        type: UPDATE_CONSULTATION_NOTES_DATA,
        data
    };
}

export function deleteConsultationNotes(data) {
    return {
        type: DEL_CONSULTATION_NOTES_DATA,
        data
    };
}

export function updateConsultationNotesVisibleStatus(data) {
    return {
        type: UPDATE_CONSULTATION_NOTES_VISIBLE_STATUS,
        data
    };
}

export function getPreviousNoteByType(data) {
    return {
        type: GET_PREVIOUS_CONSULTATION_NOTE_BY_TYPE,
        data
    };
}

export function getNotesTypeList(data) {
    return {
        type: GET_NOTES_TYPE_LIST,
        data
    };
}

export function getLabTests(data) {
    return {
        type: GET_LAB_TESTS,
        data
    };
}

export function downloadConsultationNotesExcel(data) {
  return {
      type: DOWNLOAD_CONSULTATION_NOTES_EXCEL,
      data
  };
}

export function getSessionListAgainstToNotes(data) {
    return {
        type: GET_SESSION_LIST_AGAINST_TO_NOTES,
        data
    };
  }

  export function downloadPendingNotesExcel(data) {
    return {
        type: DOWNLOAD_PENDING_NOTES_EXCEL,
        data
    };
  }